<template>
    <div class="mb-4">
        <h4 class="text-uppercase mb-3 primary--text" v-text="value.name" />

        <div class="pl-md-4">
            <v-row v-for="(skill, i) in value.keywords" :key="i" align="center" class="mb-2 mx-0">
                <v-col cols="12">
                    <!-- <v-icon size="20" color="primary" class="mr-1"> mdi-dot </v-icon> -->

                    <h5 class="subheading">
                        <v-icon color="primary">
                            mdi-circle-small</v-icon
                        > {{ skill }}
                    </h5>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                skills: [],
            }),
        },
    },
};
</script>
